import React, { Component } from 'react';

import ctabg from '../../assets/img/banner/5.jpg';

class Cta extends Component {
    render() {
        return (
            <div className="section section-lg bg-cover bg-center bg-norepeat" style={{ backgroundImage: "url(" + ctabg + ")" }}>
                <div className="container">
                    <div className="section-title text-center">
                        <h6 className="subtitle custom-secondary">About Us</h6>
                        <h4 className="title text-white"> Let Us Help You With All Of Your Printing Needs </h4>
                        <p className="text-white">Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Nulla quis lorem ut libero malesuada feugiat. Cras ultricies ligula sed.</p>
                    </div>
                </div>
                <svg className="bottom-skew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="#fff" fillOpacity={1} d="M0,320L1440,192L1440,320L0,320Z" />
                </svg>
            </div>
        );
    }
}

export default Cta;